import React, { useEffect, useState } from "react";
import PageTitleBanner from "../../Components/Reusable/PageTitleBanner";
import Image from "../../Components/Reusable/Image";
import { PngImages } from "../../Utils/LocalImages";
import { handleApiErrors, htmlToText } from "../../Utils/Utils";
import ApiService from "../../Services/ApiService";

const AboutUs = () => {
  const [cardsData, setCardsData] = useState();

  const getAboutUsPageContent = async () => {
    try {
      const response = await ApiService.getAboutUsPageContent();
      setCardsData(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  }

  useEffect(() => { getAboutUsPageContent() }, []);
  const decodeHtml = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.documentElement.textContent;
};

  return (
    <div className="d-flex flex-column mb-auto">
      <PageTitleBanner PageTitle={"About Learn and Achieve"} breadCrumpPageTitle={"About Us"} />
      <div className="about-us-page-container d-flex flex-column align-items-center m-0">
        <div className="about-us-cards-group row container">
          <div className="col-md-6 p-3">
            <div className="about-us-card d-flex flex-column p-5 gap-3" style={{ backgroundImage: "linear-gradient(to left bottom, #FCC78D, #FFE6B0)" }}>
              <div className="d-flex flex-column gap-3">
                <h2 className="Heading fw-600 black mb-0">
                  {cardsData?.cardOneTitle}
                </h2>
                <p className="Sub-Heading fw-400 black mb-0">
                  {htmlToText(decodeHtml(cardsData?.cardOneDescription.replace(/&nbsp;/g, ' ')))}
                </p>
              </div>
              <Image className="about-us-card-image align-self-end" src={PngImages.aboutUsCardOneVector} />
            </div>
          </div>

          <div className="col-md-6 p-3">
            <div className="about-us-card d-flex flex-column p-5 gap-3" style={{ backgroundImage: "linear-gradient(to left bottom, #79BDEB, #7BC5F4)" }}>
              <div className="d-flex flex-column gap-3">
                <h2 className="Heading fw-600 black mb-0">
                  {cardsData?.cardTwoTitle}
                </h2>
                <p className="Sub-Heading fw-400 black mb-0">
                  {htmlToText(decodeHtml(cardsData?.cardTwoDescription.replace(/&nbsp;/g, ' ')))}
                </p>
              </div>
              <Image className="about-us-card-image align-self-end" src={PngImages.aboutUsCardTwoVector} />
            </div>
          </div>

          <div className="col-md-6 p-3">
            <div className="about-us-card d-flex flex-column p-5 gap-3" style={{ backgroundImage: "linear-gradient(to left bottom, #539E94, #7DE1D9)" }}>
              <Image className="about-us-card-image align-self-start me-0" src={PngImages.aboutUsCardThreeVector} style={{ marginTop: -60, width: "min(80%, 300px)" }} />
              <div className="d-flex flex-column gap-3">
                <h2 className="Heading fw-600 black mb-0">
                  {cardsData?.cardThreeTitle}
                </h2>
                <p className="Sub-Heading fw-400 black mb-0">
                  {htmlToText(decodeHtml(cardsData?.cardThreeDescription.replace(/&nbsp;/g, ' ')))}
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 p-3">
            <div className="about-us-card d-flex flex-column p-5 gap-3" style={{ backgroundImage: "linear-gradient(to left bottom, #FFD058, #FFC636)" }}>
              <div className="d-flex flex-column gap-3">
                <h2 className="Heading fw-600 black mb-0">
                  {cardsData?.cardFourTitle}
                </h2>
                <p className="Sub-Heading fw-400 black mb-0">
                  {htmlToText(decodeHtml(cardsData?.cardFourDescription.replace(/&nbsp;/g, ' ')))}
                </p>
              </div>
              <Image className="about-us-card-image align-self-end" src={PngImages.aboutUsCardFourVector} />
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};
export default AboutUs;
